import { 
  Compass, 
  Ticket, 
  Map, 
  Percent,
  Star,
  Shield,
  Clock,
  Users
} from 'lucide-react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const CompassIcon = ({ className }: IconProps) => (
  <Compass className={className} />
);

export const TicketIcon = ({ className }: IconProps) => (
  <Ticket className={className} />
);

export const MapIcon = ({ className }: IconProps) => (
  <Map className={className} />
);

export const PercentIcon = ({ className }: IconProps) => (
  <Percent className={className} />
);

export const StarIcon = ({ className }: IconProps) => (
  <Star className={className} />
);

export const ShieldIcon = ({ className }: IconProps) => (
  <Shield className={className} />
);

export const ClockIcon = ({ className }: IconProps) => (
  <Clock className={className} />
);

export const UsersIcon = ({ className }: IconProps) => (
  <Users className={className} />
);
